<!--
 * @Auther: 罗耀祖
 * @Date: 2021-08-26 14:02:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-17 11:01:03
 * @name: 进度
 * @Description: 进度
 * @FilePath: \project\src\components\public\progress-list.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="progress-list">
    <div class="list">
      <!-- 第一步,经销商发起(默认展示) -->
      <div class="item">
        <div class="itembox">
          <div class="icon-box">
            <img class="icon" src="@/assets/icon/progress-finish.png" />
          </div>
          <div class="info">
            <div class="row">
              <div class="name">琴行提交申报</div>
              <div class="time">{{ create_time }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="item" v-for="(item, index) of showList" :key="index">
        <div class="itembox">
          <div class="icon-box">
            <img
              class="icon"
              src="@/assets/icon/progress-doing.png"
              v-if="item.status === 0"
            />
            <img
              class="icon"
              src="@/assets/icon/progress-finish.png"
              v-else-if="item.status === 2 && String(item.act) === 'OK'"
            />
            <img
              class="icon"
              src="@/assets/icon/progress-reject.png"
              v-else-if="item.status === 2 && String(item.act) === '-1'"
            />
            <img
              class="icon"
              src="@/assets/icon/progress-reject.png"
              v-else-if="item.status === 2 && String(item.act) === 'END'"
            />
            <div
              class="default"
              v-else-if="
                item.status === 2 && String(item.act) === 'repeat_send'
              "
            ></div>
            <div class="default" v-else></div>
          </div>
          <div class="info">
            <div class="row">
              <div class="name">{{ item.process_name }}</div>
              <div class="time">{{ item.deal_time }}</div>
            </div>
            <div class="row">
              <div class="act_des">{{ item.act_des }}</div>
            </div>
            <div class="row" v-if="item.content">
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="showMore" v-if="hasShowMore" @click="showMore = !showMore">
      <template v-if="!showMore">
        <font>展示更多</font>
        <img class="arrow" src="@/assets/icon/arrow-left-red.png" />
      </template>
      <template v-else>
        <font>收起</font>
        <img class="arrow open" src="@/assets/icon/arrow-left-red.png" />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Array,
    },
    create_time: {
      type: String,
    },
    hasShowMore: {
      type: Boolean,
      default: false,
    },
    process_type: {
      type: String,
    },
  },
  data() {
    return {
      showMore: true,
    };
  },
  computed: {
    showList() {
      let progress = this.progress;
      return this.showMore
        ? progress
        : progress.filter((item, index) => index < 3);
    },
  },
  created() {
    if (this.hasShowMore) {
      this.showMore = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.progress-list {
  width: 100%;
  padding-top: 24px;
  padding-left: 8px;
  box-sizing: border-box;
  .noNeedDeal {
    font-size: $Vars-font-content-size;
  }
  .list {
    width: 100%;
    box-sizing: border-box;
    @extend .et-flex-column-normal;
    .item {
      width: 100%;
      padding-bottom: 45px;
      border-left: 1px solid $Vars-font-placeholder-color;
      &:last-child {
        padding-bottom: 0 !important;
        border-left: 0 !important;
      }
      .itembox {
        margin-left: -8px;
        margin-top: 0;
        transform: translateY(-50%);
        @extend .et-flex-spacebetween;
        .icon-box {
          width: 16px;
          height: 16px;
          margin-right: 16px;
          .icon {
            width: 16px;
            height: 16px;
            background: white;
          }
          .default {
            width: 16px;
            height: 16px;
            border-radius: 16px;
            background: $Vars-font-placeholder-color;
          }
        }
        .info {
          flex: 1;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            @extend .et-flex-spacebetween;
            align-items: flex-start;
            &:not(:first-child) {
              margin-top: 5px;
            }
            .name {
              font-size: 12px;
              flex: 1;
              word-break: break-all;
            }
            .time {
              font-size: 12px;
              color: $Vars-font-placeholder-color;
              flex-shrink: 0;
              margin-left: 5px;
            }
            .act_des {
              font-size: 12px;
              color: $Vars-font-secondary-color;
            }
            .content {
              font-size: 12px;
              color: $Vars-font-secondary-color;
            }
          }
        }
      }
    }
  }
  .showMore {
    width: 100%;
    height: 45px;
    @extend .et-flex-center;
    text {
      font-size: 14px;
      color: $Vars-font-secondary-color;
      margin-right: 10px;
    }
    .arrow {
      width: 9px;
      height: 16px;
      transform: rotate(270deg);
      &.open {
        transform: rotate(90deg);
      }
    }
  }
}
</style>